var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineScreenmirroring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6 19.25c-1.92 0-2.85-.93-2.85-2.85v-1.8c0-1.92.93-2.85 2.85-2.85h3.8c1.92 0 2.85.93 2.85 2.85v1.8c0 1.92-.93 2.85-2.85 2.85h-3.8zm-1.35-4.65v1.8c0 1.08.27 1.35 1.35 1.35h3.8c1.08 0 1.35-.27 1.35-1.35v-1.8c0-1.08-.27-1.35-1.35-1.35h-3.8c-1.08 0-1.35.27-1.35 1.35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineScreenmirroring);
export default __webpack_public_path__ + "static/media/vuesax-outline-screenmirroring.d26ed02bf7bb7149fb989c8ef1c4162d.svg";
export { ForwardRef as ReactComponent };